// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__U0VJD","tooltiptext":"tooltip_tooltiptext__fZi2q"};